import { useGetDeviationAnalysis } from 'ClientPortal/src/api/Queries/value-overview'
import { throwOnForbiddenApiError } from 'ClientPortal/src/api/react-query-config'
import { getLeadingValuesPerSqmDeviationAnalysis, getPerAreaLabels } from 'ComponentLibrary'
import { useTranslation } from 'react-i18next'

type ValueCheckDeviationAnalysisParams = {
    valueCheckId?: string
    comparisonValuationId?: string
}

export function useValueCheckDeviationAnalysis({ valueCheckId, comparisonValuationId }: ValueCheckDeviationAnalysisParams) {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { data: deviationAnalysis, isPending } = useGetDeviationAnalysis({
        baseValueCheckId: valueCheckId,
        comparisonValuationId,
        throwOnError: throwOnForbiddenApiError,
    })
    const perAreaLabels = getPerAreaLabels(tCommon)

    return {
        deviationAnalysis: deviationAnalysis && {
            ...deviationAnalysis,
            leading_market_value_per_area: getLeadingValuesPerSqmDeviationAnalysis(deviationAnalysis, perAreaLabels),
        },
        isDeviationAnalysisPending: isPending,
    }
}
